<template>
  <div v-wechat-title="$route.meta.title">
    <common-header></common-header>
    <common-nav :locale="locale"></common-nav>
    <common-banner title="about"></common-banner>
    <!-- 企业简介 -->
    <u-animate-container class="company_profile">
      <u-animate
        class="bg_left"
        name="fadeInLeft"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      ></u-animate>
      <div class="container">
        <u-animate
          class="title_en"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          COMPANY PROFILE
        </u-animate>
        <u-animate
          class="title_cn"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          企业简介
        </u-animate>
        <u-animate
          class="title_line"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        ></u-animate>
        <u-animate
          class="profile_content"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          {{ $t("about.profileContent") }}
        </u-animate>
        <u-animate
          class="profile_content"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          {{ $t("about.profileContent2") }}
        </u-animate>
      </div>
      <u-animate
        name="bounceInLeft"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <img src="@/assets/images/map.png" alt="sailuk地图" class="map" />
      </u-animate>
    </u-animate-container>
    <!-- 合作伙伴 -->
    <u-animate-container class="company_partner" :style="partner_bg">
      <div class="container">
        <u-animate
          class="top"
          :style="partner_quote"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          {{ $t("about.companyDesc") }}
        </u-animate>
        <div class="list">
          <u-animate
            class="item"
            name="slideInLeft"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <img src="@/assets/images/icon_partner_crrc.png" />
          </u-animate>
          <u-animate
            class="item"
            name="slideInRight"
            delay="0.2s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <img src="@/assets/images/icon_partner_cnnc.png" />
          </u-animate>
          <u-animate
            class="item"
            name="slideInLeft"
            delay="0.4s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <img src="@/assets/images/icon_partner_honda.png" />
          </u-animate>
          <u-animate
            class="item"
            name="slideInRight"
            delay="0.6s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <img src="@/assets/images/icon_partner_eternit.png" />
          </u-animate>
          <u-animate
            class="item"
            name="slideInLeft"
            delay="0.8s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <img src="@/assets/images/icon_partner_ikea.png" />
          </u-animate>
          <u-animate
            class="item"
            name="slideInRight"
            delay="1s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <img src="@/assets/images/icon_partner_siemens.png" />
          </u-animate>
          <u-animate
            class="item"
            name="slideInLeft"
            delay="1.2s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <img src="@/assets/images/icon_partner_samsung.png" />
          </u-animate>
          <u-animate
            class="item"
            name="slideInRight"
            delay="1.4s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <img src="@/assets/images/icon_partner_foxconn.png" />
          </u-animate>
        </div>
      </div>
    </u-animate-container>
    <!-- 高效率合作 -->
    <u-animate-container class="efficient_collaboration">
      <div class="container">
        <u-animate
          class="ec_en"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          HIGHLY EFFECTIVE COOPERATION
        </u-animate>
        <u-animate
          class="ec_cn"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          高效率合作
        </u-animate>
        <u-animate
          class="ec_line"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        ></u-animate>
        <u-animate
          class="ec_p"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          {{ $t("about.efficientCollaboration.p1") }}
        </u-animate>
        <u-animate
          class="ec_p"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          {{ $t("about.efficientCollaboration.p2") }}
        </u-animate>
        <u-animate
          class="ec_p"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          {{ $t("about.efficientCollaboration.p3") }}
        </u-animate>
        <u-animate
          class="ec_xlsx"
          :style="xlsx_bg"
          name="fadeIn"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          <span>{{ $t("about.efficientCollaboration.p4") }}</span
          ><span class="last">{{ $t("about.efficientCollaboration.p5") }}</span>
          <img src="@/assets/images/icon1.png" />
        </u-animate>
        <div class="ec_three">
          <div class="item">
            <u-animate
              class="item_img"
              name="fadeIn"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="0"
              animateClass="animated"
              :begin="false"
            >
              <img src="@/assets/images/icon_about_quality.png" />
            </u-animate>
            <u-animate
              class="item_txt"
              name="fadeIn"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="0"
              animateClass="animated"
              :begin="false"
            >
              {{ $t("about.efficientCollaboration.quality") }}
            </u-animate>
          </div>
          <div class="item">
            <u-animate
              class="item_img"
              name="fadeIn"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="0"
              animateClass="animated"
              :begin="false"
            >
              <img src="@/assets/images/icon_about_rapid.png" />
            </u-animate>
            <u-animate
              class="item_txt"
              name="fadeIn"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="0"
              animateClass="animated"
              :begin="false"
            >
              {{ $t("about.efficientCollaboration.rapid") }}
            </u-animate>
          </div>
          <div class="item">
            <u-animate
              class="item_img"
              name="fadeIn"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="0"
              animateClass="animated"
              :begin="false"
            >
              <img src="@/assets/images/icon_about_custom.png" />
            </u-animate>
            <u-animate
              class="item_txt"
              name="fadeIn"
              delay="0s"
              duration="1s"
              :iteration="1"
              :offset="0"
              animateClass="animated"
              :begin="false"
            >
              {{ $t("about.efficientCollaboration.custom") }}
            </u-animate>
          </div>
        </div>
      </div>
    </u-animate-container>
    <common-footer :locale="locale"></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonBanner from "./components/Common/Banner";
export default {
  components: {
    UAnimateContainer,
    UAnimate,
    CommonNav,
    CommonHeader,
    CommonFooter,
    CommonBanner
  },
  created() {
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
    // this.$route.meta.title = '动态修改的首页'
  },
  data() {
    return {
      locale: "zh-cn",
      partner_bg: {
        background: "url(" + require("@/assets/images/bg_partner.jpg") + ")",
        "background-size": "100% 100%"
      },
      partner_quote: {
        background:
          "url(" + require("@/assets/images/quote.png") + ") no-repeat",
        "background-size": "100% 100%"
      },
      xlsx_bg: {
        background:
          "url(" + require("@/assets/images/bg_xlsx.png") + ") no-repeat",
        "background-size": "100% 100%"
      }
    };
  },
  methods: {}
};
</script>

<style scoped lang="scss">
.container {
  width: 1140px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  padding: 60px 0;
}
.company_profile {
  position: relative;
  .bg_left {
    background: #f2f2f2;
    width: 55%;
    height: 460px;
    position: absolute;
    top: 100px;
    left: 0;
    z-index: -1;
  }
  .title_en {
    color: #fd8204;
    font-size: 0.15rem;
  }
  .title_cn {
    color: #333;
    font-size: 0.55rem;
    margin-top: 10px;
  }
  .title_line {
    width: 80px;
    background: #ff5e17;
    margin: 45px 0;
    height: 2px;
  }
  .profile_content {
    width: 50%;
    height: auto;
    font-size: 0.17rem;
    color: #333;
    line-height: 1.8;
  }
  img.map {
    margin: 60px auto;
    display: block;
  }
}
.company_partner {
  .top {
    box-sizing: border-box;
    display: block;
    padding: 0 80px;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
    font-size: 0.16rem;
    color: #fff;
    height: 50px;
    line-height: 2.2;
    text-align: center;
    margin-bottom: 60px;
  }
  .list {
    display: flex;
    display: -ms-flexbox;
    flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    justify-content: space-between;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
    .item {
      width: 25%;
      display: flex;
      display: -ms-flexbox;
      justify-content: center;
      align-items: center;
      height: 100px;
    }
  }
}
.efficient_collaboration {
  color: #fff;
  background: #fd8103;
  box-sizing: border-box;
  .container {
    overflow: inherit;
    .ec_en {
      font-size: 0.15rem;
      text-align: center;
    }
    .ec_cn {
      font-size: 0.45rem;
      text-align: center;
      margin-top: 10px;
    }
    .ec_line {
      background: #fff;
      height: 2px;
      width: 80px;
      display: block;
      margin: 45px auto;
    }
    .ec_p {
      font-size: 0.17rem;
      text-align: center;
      line-height: 2;
    }
    .ec_xlsx {
      width: 1140px;
      margin: 45px auto;
      display: flex;
      display: -ms-flexbox;
      justify-content: center;
      color: #333;
      font-size: 0.26rem;
      height: 140px;
      line-height: 125px;
      position: relative;
      font-weight: bold;
      span {
        position: relative;
        z-index: 999;
        &.last {
          color: #dd5629;
          margin-left: 5px;
        }
      }
      img {
        position: absolute;
        width: 300px;
        right: -160px;
        top: -286px;
      }
    }
    .ec_three {
      display: flex;
      display: -ms-flexbox;
      box-sizing: border-box;
      border: 2px solid #fff;
      color: #fff;
      width: 800px;
      margin: 0 auto 60px;
      .item {
        width: 33%;
        display: flex;
        display: -ms-flexbox;
        align-items: center;
        justify-content: center;
        flex: 1;
        -ms-flex: 1;
        flex-direction: row;
        background: #fe9528;
        height: 180px;
        img {
          width: 100px;
          height: auto;
        }
        .item_txt {
          font-size: 0.25rem;
          margin-left: 20px;
        }
        &:nth-of-type(2) {
          border-left: 2px solid #fff;
          border-right: 2px solid #fff;
        }
        &:hover {
          background: #fd8f1e;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .container {
    width: 100%;
    padding: 30px 0;
    box-sizing: border-box;
  }
  .company_profile {
    .bg_left {
      background: none;
    }
    .container {
      padding: 15px 30px;
    }
    .title_cn {
      font-size: 1.5rem;
      text-align: center;
      font-weight: bold;
      margin-bottom: 15px;
    }
    .title_en {
      font-size: 0.5rem;
      text-align: center;
    }
    .title_line {
      margin: 15px 0;
      display: none;
    }
    .profile_content {
      width: 100%;
      font-size: 0.7rem;
    }
    img.map {
      width: 100%;
      margin: 15px auto;
    }
  }
  .company_partner {
    .top {
      width: 90%;
      padding: 0 30px;
      height: 1.2rem;
    }
    .list {
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      .item {
        width: 50%;
      }
    }
  }
  .efficient_collaboration {
    .container {
      .ec_en {
        font-size: 0.5rem;
      }
      .ec_cn {
        font-size: 1rem;
        font-weight: bold;
      }
      .ec_line {
        margin: 15px auto;
      }
      .ec_p {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        font-size: 0.7rem;
      }
      .ec_xlsx {
        width: 95%;
        margin: 15px auto;
        font-size: 0.6rem;
        height: 5rem;
        line-height: 4.6rem;
        img {
          display: none;
        }
      }
      .ec_three {
        width: 100%;
        margin: 0 auto 15px;
        box-sizing: border-box;
        padding: 0 15px;
        border: 0;
        .item {
          flex-direction: column;
          height: 120px;
          border: 1px solid #fff;
          &:nth-of-type(2) {
            border-left: 0;
            border-right: 0;
          }
          .item_img {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 80px;
            height: 80px;
            img {
              width: 45px;
            }
          }
          .item_txt {
            font-size: 0.8rem;
            margin: 0.2rem auto 0.5rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/About.vue